<app-power-bi reportId="POI_DETAILS_DASHBOARD" height="750" [filters]="powerBiFilters" *ngIf="powerBiFilters"></app-power-bi>

